export const googleAdsConversionScriptSrc =
  'https://www.googletagmanager.com/gtag/js?id=AW-17701027103';

export const googleAdsConversionInlineScript = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-17701027103');
`;

